import React from 'react';
import { keyframes, styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingBar = ({
  isLoading,
  zIndex
}) => /*#__PURE__*/_jsx(LoadingBarContainer, {
  isLoading: isLoading,
  zIndex: zIndex,
  children: /*#__PURE__*/_jsx(Bar, {})
});
const loadingBarHeight = 4;
const indeterminateShort = keyframes`
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
}

`;
const indeterminate = keyframes`
  0% {
    left: -35%;
    right: 100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
`;
const LoadingBarContainer = styled.div.withConfig({
  displayName: "LoadingBar__LoadingBarContainer",
  componentId: "sc-1sgzu8g-0"
})(["position:absolute;height:", ";top:0;left:0;right:0;overflow:hidden;background:", ";transition:height 350ms ease-in-out;z-index:", ";"], ({
  isLoading
}) => isLoading ? `${loadingBarHeight}px` : '0', Colors.RED_a36d77, props => props.zIndex ? props.zIndex : 'initial');
const Bar = styled.div.withConfig({
  displayName: "LoadingBar__Bar",
  componentId: "sc-1sgzu8g-1"
})(["background-color:", ";&:before{content:'';position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right;animation:", " 2.1s cubic-bezier(0.65,0.815,0.735,0.395) infinite;}&:after{content:'';position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right;animation:", " 2.1s cubic-bezier(0.165,0.84,0.44,1) infinite;animation-delay:1.15s;}"], Colors.RED_af001e, indeterminate, indeterminateShort);